import React from 'react';
import "./ColumnColors.scss";

const KCBAreaColors = {
  "Khu khám tầng 1": {
    color: "#E09B06",
  },
  "Khu khám tầng 2": {
    color: "#4C73E6",
  },
};

const KCBAreaColumn = ({label}: {label: string}) => {
  return (
    <div
      className="color-column"
      style={{backgroundColor: KCBAreaColors[label]?.color, color: KCBAreaColors[label] ? "": "black"}}
    >
      {label}
    </div>
  )
}

export default KCBAreaColumn;